module.exports = __webpack_public_path__ + "static/main-photo2-43365827d327ad08254b1931111414ea.jpg";